"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaComponent = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_simple_captcha_1 = require("react-simple-captcha");
const CaptchaComponent = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const [value, setValue] = react_1.default.useState('');
    (0, react_1.useEffect)(() => {
        (0, react_simple_captcha_1.loadCaptchaEnginge)(6);
    }, []);
    (0, react_1.useEffect)(() => {
        // Do not reset the value or set parent validation status as we want to
        // keep the captcha if it was valid
        (0, react_simple_captcha_1.validateCaptcha)(value, true);
    }, [props.reloadKey]);
    const handleChange = (e) => {
        setValue(e.target.value);
        if ((0, react_simple_captcha_1.validateCaptcha)(e.target.value, false)) {
            props.onCaptchaValid(true, e.target.value);
        }
        else {
            props.onCaptchaValid(false);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_simple_captcha_1.LoadCanvasTemplate, { reloadText: t('auth:ReloadCaptchaText') })),
        react_1.default.createElement("div", { className: "apptr__form-input-container" },
            react_1.default.createElement("label", { className: "_flex" }, t('auth:EnterCaptchaText')),
            react_1.default.createElement("input", { name: "userCaptcha", type: "text", className: 'apptr__form-input apptr__form-input-string apptr__input apptr__input-string', value: value, onChange: handleChange }))));
};
exports.CaptchaComponent = CaptchaComponent;
exports.default = exports.CaptchaComponent;
//# sourceMappingURL=SimpleCaptcha.js.map